export enum REPORT_TYPE {
  RAW_CLICKS = 'raw-clicks',
  RAW_EVENTS = 'raw-events',
  RAW_POSTBACKS = 'raw-postbacks',
}
